import { Flex, Icon, Text } from "@chakra-ui/react"
import { FiAlertTriangle } from "react-icons/fi"

export const NoPermission = () => {
    return (
        <Flex h={60} w="100%" justifyContent="center" alignItems="center">
            <Icon as={FiAlertTriangle} size="xl" mr={4} color="danger" />
            <Text fontSize={20}>Du hast keine Berechtigung für diesen Bereich!</Text>
            <Icon as={FiAlertTriangle} size="xl" ml={4} color="danger" />
        </Flex>
    )
}